import { createAction, props } from '@ngrx/store';
import { ILoginModel, IAuthenticatedModel } from './login.models';

export const login = createAction('[Login] Login', props<{ payload: ILoginModel }>());

export const loginSuccess = createAction(
  '[Login] Login Success',
  props<{ email: string; response: IAuthenticatedModel }>(),
);

export const loginFailure = createAction('[Login] Login Failure', props<{ error: string }>());

export const logout = createAction('[Login Page] Logout');

export const resetLogin = createAction('[Login] Reset');
